import React from "react";
import { APP } from "../../constant/theme";

const Footer = ({ hideCopyright = false }) => {
  const credit = APP.developerCredit;

  return (
    <footer className="app-footer">
      {!hideCopyright && <div className="app-footer-left">{APP.copyright}</div>}

      {credit?.show && (
        <div className="app-footer-right">
          <a href={credit.url} target="_blank" rel="noopener noreferrer">
            {credit.label} {credit.company}
          </a>
        </div>
      )}
    </footer>
  );
};

export default Footer;
